<template>
	<div>

		<template v-if="!data">
			<button v-on:click="load" :disabled="saving">Load</button>
		</template>
		<template v-else>

			<div v-if="data.debt_collection">
				<div class="margin-bottom">
					<div>
						<strong>Started on:</strong>
					</div>
					<Format type="date" :time="true" :value="data.debt_collection.created_at" />
				</div>
				<div class="margin-bottom">
					<div>
						<strong>Settled</strong>
					</div>
					<template v-if="data.debt_collection.settled_at">
						<Format type="date" :time="true" :value="data.debt_collection.settled_at" />
					</template>
					<template v-else>Not yet settled</template>
				</div>
				<button class="small-margin-right" v-if="!data.debt_collection.settled_at" :disabled="saving" v-on:click="settle">Settle</button>
				<button v-if="data.debt_collection.settled_at" :disabled="saving" v-on:click="unsettle">Un-settle</button>
				<button v-if="!data.debt_collection.settled_at" v-on:click="cancelling = !cancelling">Cancel/delete</button>
        <button
          class="small-margin-left"
          :disabled="saving"
          v-if="!data.debt_collection.settled_at"
          v-on:click="resend">Resubmit case to agency</button>

				<div class="margin-top" v-if="!data.debt_collection.settled_at && cancelling">
					<textarea cols="50" rows="4" v-model="cancel_comment"></textarea>
					<div class="small-margin-top">
						<button :disabled="saving || !cancel_comment" v-on:click="cancel">Confirm deletion</button>
					</div>
				</div>
			</div>
			<div v-else>
				<button :disabled="saving" v-on:click="start">Start debt collection</button>
			</div>

		</template>

	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  props: [
    'id',
    'autoload'
  ],
  data: () => ({
    data: false,
    saving: false,
    cancelling: false,
    cancel_comment: ''
  }),
  methods: {
    load () {
      Vue.$api.get('/order/' + this.id + '/debt-collection', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.data = data
      })
    },
    start () {
      Vue.$api.post('/order/' + this.id + '/debt-collection/start', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    settle () {
      Vue.$api.post('/order/' + this.id + '/debt-collection/settle', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    resend () {
      if (!confirm('Are you sure? It is important you understand the consequences of doing this.')) {
        return
      }
      Vue.$api.post('/order/' + this.id + '/debt-collection/resend', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    unsettle () {
      Vue.$api.post('/order/' + this.id + '/debt-collection/unsettle', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    cancel () {
      if (confirm('Are you sure? This will delete debt collection record. You must communicate this to Likvido.')) {
        Vue.$api.post('/order/' + this.id + '/debt-collection/cancel', {
          comment: this.cancel_comment
        }, {
          loader: toggle => this.saving = toggle,
          callback: data => this.load()
        })
      }
    }
  },
  created () {
    if (this.autoload) {
      this.load()
    }
  }
}
</script>
